module.exports = __webpack_public_path__ + "static/media/ui-submission.a3b2e27e.png";